
<div class="d-flex section-p seller-p-top main-body main-section">
  <div class="container-p" style="flex-wrap:wrap">
    <div class="col-6">
      <div class="gray-box">
        <div class="mb-30">
          <img src="https://wpbe-testing.fingent.net/wp-content/uploads/2022/01/price-my-property-1536x640.png" class="img-fluid" />
        </div>
        <h2 class="hd-1 mb-20">Whats Your Property Worth?</h2>
        <p class="body-p-1">With billions in transaction experience across all net lease assets types, B+E gives you the best pricing in today’s market</p>
      </div>
    </div>
    <div class="col-6">
      <div class="gray-box">
        <div class="mb-30">
          <img src="https://be-dev.fingent.net/wp-content/uploads/2022/02/we-have-buy-needs.png" class="img-fluid" />
        </div>
        <h2 class="hd-1 mb-20">Exclusive Buy Needs</h2>
        <p class="body-p-1">Submit your property to find out if it matches any of B+E’s Exclusives Buyer Needs.</p>
      </div>
    </div>
    <div class="col-12 text-center margin-top-30 mb-20">
      <button class="btn btn-success btn-lg btn-send-inquiry" (click)="sendMail();"> Request Demo </button>
    </div>
  </div>
</div>

<div class="d-flex section-p gray-bg why-be-wrap">
  <div class="container-p flex-wrap-wrap">
    <div class="col-12">
      <h2 class="text-center hd mb-50"> Why B+E ?</h2>
    </div>
    <div class="d-flex flex-wrap-wrap">
      <div class="row">
        <div class="col-6">
          <div class="be-box-1 mb-30">
            <figure class="image-box-img">
              <img src="https://wpbe-testing.fingent.net/wp-content/uploads/2020/07/1793151.svg" />
            </figure>
            <div class="box-content">
              <h3 class="hd-2 mb-10">Industry Leading Technology</h3>
              <p class="body-p-2">B+E uses proprietary technology to streamline each phase of the transaction process. We place customized tools in the hands of the seller, giving you greater confidence and control.</p>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="be-box-1 mb-30">
            <figure class="image-box-img">
              <img src="https://wpbe-testing.fingent.net/wp-content/uploads/2020/07/working.svg" />
            </figure>
            <div class="box-content">
              <h3 class="hd-2 mb-10">Billions in Experience</h3>
              <p class="body-p-2">B+E’s national team of brokers has billions in transaction experience across all types of net lease real estate.</p>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="be-box-1 mb-30">
            <figure class="image-box-img">
              <img src="https://wpbe-testing.fingent.net/wp-content/uploads/2020/07/2245170.svg" />
            </figure>
            <div class="box-content">
              <h3 class="hd-2 mb-10">Largest Data Set In Net Lease</h3>
              <p class="body-p-2">
                B+E leverages the largest single-tenant, net-lease database to track property values and market conditions so we can accurately value your asset(s).

              </p>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="be-box-1 mb-30">
            <figure class="image-box-img">
              <img src="https://wpbe-testing.fingent.net/wp-content/uploads/2020/07/social-media-marketing.svg" />
            </figure>
            <div class="box-content">
              <h3 class="hd-2 mb-10">
                Marketing Reach
              </h3>
              <p class="body-p-2">
                B+E uses multiple marketing channels to reach the full spectrum of buyers including REITs, family offices, high-net-worth individuals, private equity, and many more.

              </p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<div class="d-flex section-p seller-dashboard-wrap">
  <div class="container-p flex-wrap-wrap">
    <div class="col-12">
      <h2 class="text-center hd mb-50">Seller Dashboard</h2>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="seller-box gray-box">
          <figure class="seller-box-img">
            <img src="https://wpbe-testing.fingent.net/wp-content/uploads/2020/07/1-1-1024x683.jpg" class="img-fluid" />
          </figure>
          <div class="seller-box-text">
            <h3 class="hd-2 mb-10">Streamline the Selling Process</h3>
            <p class="body-p-2">B+E uses multiple marketing channels to reach the full spectrum of buyers including REITs, family offices, high-net-worth individuals, private equity, and many more.</p>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="seller-box gray-box">
          <div class="seller-box-text">
            <h3 class="hd-2 mb-10">Monitor Real Time Market Feedback and Activity</h3>
            <p class="body-p-2">
              Our dashboard compiles real-time market feedback from brokers and principals giving you insight into your asset(s)’ sales performance, along with important metrics such as listing views, OM downloads, outbound calls, and outbound emails.
            </p>
          </div>
          <figure class="seller-box-img">
            <img src="https://wpbe-testing.fingent.net/wp-content/uploads/2020/08/2-1024x683.jpg" class="img-fluid" />
          </figure>

        </div>
      </div>
      <div class="col-12">
        <div class="seller-box gray-box">
          <figure class="seller-box-img">
            <img src="https://wpbe-testing.fingent.net/wp-content/uploads/2020/07/3-1-1024x683.jpg" class="img-fluid" />
          </figure>
          <div class="seller-box-text">
            <h3 class="hd-2 mb-10">
              Make Data Driven Decisions
            </h3>
            <p class="body-p-2">
              Make informed decisions as B+E compiles and ranks all offers based on the buyer profile and the strength of the offer – then you can compare offers instantly right in the dashboard. Our seller dashboard also uses financial API’s so you can customize your dashboard to monitor the latest stock information and news related to your tenant(s).
            </p>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="seller-box gray-box">
          <div class="seller-box-text">
            <h3 class="hd-2 mb-10">
              Enhance Communication and
              Organization
            </h3>
            <p class="body-p-2">
              Keep your transaction(s) on track with innovative tools such as an interactive critical dates calendar, instant messaging capabilities, and storage of all due diligence documents. These tools increase collaboration, keep everyone updated on the transaction progress, and take easily lost documents out of your inbox.
            </p>
          </div>
          <figure class="seller-box-img">
            <img src="https://wpbe-testing.fingent.net/wp-content/uploads/2020/08/4-1024x683.jpg" class="img-fluid" />
          </figure>

        </div>
      </div>
    </div>
  </div>
</div>


